import React, { useContext, useState } from 'react';

import DataTypePill from 'app/components/CommonStyled/DataTypePill/DataTypePill';
import { KeyIcon } from 'app/components/shared/icons';

import PeopleDrawerContactIcon from '../PeopleDrawerContactIcon';
import { PeopleDrawerContext } from '../PeopleDrawerContext';
import {
  PeopleDrawerAccountHolderClientsWrapper,
  PeopleDrawerAccountHolderTitle,
  PeopleDrawerAccountHolderTitleContainer,
  PeopleDrawerAccountHolderTitleWrapper,
  PeopleDrawerAccountHolderWrapper,
} from './styled';

export default function PeopleDrawerAccountHolder() {
  const { person } = useContext(PeopleDrawerContext);
  const [showAll, setShowAll] = useState(false);

  const accountHolders = person?.info.account_holder_info ?? [];
  const hasMoreThanFive = accountHolders.length > 5;
  const displayedClients = showAll ? accountHolders : accountHolders.slice(0, 5);
  const remainingCount = accountHolders.length - 5;

  return (
    <PeopleDrawerAccountHolderWrapper>
      <PeopleDrawerAccountHolderTitleWrapper>
        <PeopleDrawerAccountHolderTitleContainer>
          <KeyIcon width={20} height={20} fill="var(--color-text)" />
          <PeopleDrawerAccountHolderTitle>
            {person?.info.name?.split(' ')[0]} is an account holder for:
          </PeopleDrawerAccountHolderTitle>
        </PeopleDrawerAccountHolderTitleContainer>
        <PeopleDrawerContactIcon />
      </PeopleDrawerAccountHolderTitleWrapper>
      <PeopleDrawerAccountHolderClientsWrapper>
        {displayedClients.map((client) => (
          <DataTypePill
            key={client.uuid}
            title={client.name}
            type={client?.type && client?.type === 'member_companies' ? 'company' : 'client'}
            clickable={false}
          />
        ))}
        {hasMoreThanFive && !showAll && (
          <DataTypePill
            type="more"
            title={`+${remainingCount} more`}
            onClick={() => setShowAll(true)}
            clickable={true}
          />
        )}
      </PeopleDrawerAccountHolderClientsWrapper>
    </PeopleDrawerAccountHolderWrapper>
  );
}
